export class ConsultaFuenteI{
    anio : any;
    trimestre : any;
    cod_entidad : any;
    idFuente : any;
  }
